import { cn } from "@/lib/utils";
import React from "react";

type TimelineItemProps = {
  children: React.ReactNode;
  className?: string;
};

const TimelineItem: React.FC<TimelineItemProps> = ({ children, className }) => (
  <div className={cn("w-full", className)}>{children}</div>
);
TimelineItem.displayName = "TimelineItem";

type TimelineProps = {
  children: React.ReactNode;
};

const Timeline: React.FC<TimelineProps> = ({ children }) => {
  const timelineItems = React.Children.toArray(children);

  return (
    <div className="flex flex-col">
      {timelineItems.map((child, index) => {
        const isLast = index === timelineItems.length - 1;

        return (
          <div key={index} className="flex">
            {/* Left gutter: dot + connecting line */}
            <div className="flex flex-col items-center shrink-0">
              <div className="h-3 w-3 shrink-0 rounded-full bg-gray-300" />
              {!isLast && <div className="w-[2px] flex-1 bg-border" />}
            </div>
            {/* Content */}
            <div className={cn("ml-4 w-full", !isLast && "pb-6")}>
              {child}
            </div>
          </div>
        );
      })}
    </div>
  );
};
Timeline.displayName = "Timeline";

export { Timeline, TimelineItem };
